import React from "react";

import {
  Button,
  CircularProgress,
  Grid,
  makeStyles,
  SvgIcon,
  Typography,
} from "@material-ui/core";

const useStyles = makeStyles(() => ({
  root: {
    margin: "10px",
    borderRadius: "50%",
    width: 52, // Increased from 50
    height: 52, // Increased from 50
    minWidth: 52,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  rootFullWidth: {
    borderRadius: "10px",
    width: "100%",
    height: "48px",
    // width: 52, // Increased from 50
    // height: 52, // Increased from 50
    // minWidth: 52,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
}));

export interface SocialSignInButtonProps {
  handleClick?: (e: any) => void;
  logoSrc?: any;
  isLoading?: boolean;
  backColour?: any;
  isFullWidth?: any;
  labelText?: any;
  backText?: any;
  marginLeft?: any;
}

const SocialSignInButtonWithLogo: React.SFC<SocialSignInButtonProps> = ({
  handleClick,
  logoSrc,
  isLoading,
  backColour,
  isFullWidth,
  labelText,
  backText,
  marginLeft,
}) => {
  const classes = useStyles();
  return (
    <Button
      variant="contained"
      size="large"
      onClick={handleClick}
      classes={{ root: isFullWidth ? classes.rootFullWidth : classes.root }}
      disabled={isLoading}
      style={{ backgroundColor: backColour }}
    >
      <Grid container>
        <Grid item xs={12} style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
         <div style={{width: "212px", display: "flex", alignItems: "center"}}>
           {typeof logoSrc === "string" ? (
            <img
              src={logoSrc}
              alt={"alt"}
              style={{ width: 24, height: 24, marginRight: 8 }}
            />
          ) : (
            <SvgIcon>{logoSrc}</SvgIcon>
          )}

           {isLoading ? (
            <CircularProgress
              size={20}
              style={{ color: backText, marginLeft: '8px' }}
            />
          ) : (
            <Typography
              variant="subtitle2"
              align="left"
              style={{ color: backText, marginLeft: '8px', paddingTop: "2px" }}
            >
              {labelText}
            </Typography>
          )}
          </div>
        </Grid>
         
      </Grid>
    </Button>
  );
};

export default SocialSignInButtonWithLogo;
